module.exports = __webpack_public_path__ + "static/media/UserExperience.6e9d2b5f.png";